import { Switch } from "@headlessui/react";

const ToggleSwitch = ({ isActive, onChange, label = "", disabled = false }) => {
    return (
        <div className="flex items-center gap-3">
            <Switch
                checked={isActive}
                onChange={onChange}
                disabled={disabled}
                className={`${
                    isActive ? "bg-blue-600" : "bg-gray-300"
                } relative inline-flex h-6 w-12 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
            >
                {/* YES/NO text inside toggle */}
                <span className="absolute left-1.5 text-[8px] font-bold text-white uppercase">
                    {isActive ? "YES" : "NO"}
                </span>
                
                <span
                    className={`${
                        isActive ? "translate-x-7" : "translate-x-0.5"
                    } inline-block h-5 w-5 transform rounded-full bg-white shadow-sm transition-transform duration-200 ease-in-out`}
                />
            </Switch>
            
            {/* Label text next to toggle */}
            {label && (
                <span className="text-sm font-medium text-gray-700">
                    {label}
                </span>
            )}
        </div>
    );
};

export default ToggleSwitch;